import type {
  QuestionResponseSchema,
  UnregisteredPropertyResponseSchema,
} from "@/hera-api/client/types.gen";
import { getRegistrationTaggedQuestion } from "@/lib/service-transfer-wizard";
import type { AddressDetails } from "@/types/address";
import type { LicenseAnswers } from "@/types/license";

export function unregisteredPropertyAddressPrefill(
  unregistered: UnregisteredPropertyResponseSchema,
): AddressDetails | null {
  const property = unregistered.property;
  if (!property) return null;
  return {
    address1: property.address1,
    address2: property.address2,
    city: property.city,
    state: property.state,
    zipcode: property.zipcode,
    apn: property.apn,
  };
}

function ownerContactPrefill(
  unregistered: UnregisteredPropertyResponseSchema,
): Record<string, string> | null {
  const answer = {
    name: unregistered.owner_name?.trim() ?? "",
    companyName: "",
    email: unregistered.owner_email?.trim() ?? "",
    phone: unregistered.owner_phone?.trim() ?? "",
    addressLine1: unregistered.owner_address1?.trim() ?? "",
    addressLine2: unregistered.owner_address2?.trim() ?? "",
    city: unregistered.owner_city?.trim() ?? "",
    state: unregistered.owner_state?.trim() ?? "",
    zipCode: unregistered.owner_zip?.trim() ?? "",
  };
  return Object.values(answer).some(Boolean) ? answer : null;
}

/**
 * Reuse exact saved question answers first, then fill the registration's OMT
 * contact from the standalone owner fields when that question is still blank.
 */
export function unregisteredRegistrationAnswersPrefill(
  unregistered: UnregisteredPropertyResponseSchema,
  questions?: QuestionResponseSchema[],
): LicenseAnswers {
  const answers: Record<string, unknown> = {
    ...(unregistered.answers_to_additional_questions ?? {}),
    effective_date: unregistered.effective_date,
  };
  const omtQuestion = getRegistrationTaggedQuestion(questions, "OMT");
  const owner = ownerContactPrefill(unregistered);
  if (omtQuestion && owner && answers[omtQuestion.id] == null) {
    answers[omtQuestion.id] = owner;
  }
  return answers as LicenseAnswers;
}
